/**
 * validator
 *
 * @author Shigq
 * @date 2021/5/18 15:49
 */
import { useI18n } from '../plugins/i18n'
import { utils } from "@libs/dep-private";

const { validator, currencyUtils } = utils

export default function () {
	// todo - declare
	const { t } = useI18n()

	// todo - validate
	const scopedValidators = {
		validateMobilePhone(rule, value, callback) {
			if (!validator.isMobilePhone(value)) {
				callback(new Error(t('common.validate.mobilePhone')));
			} else {
				callback()
			}
		},
		validateEmail(rule, value, callback) {
			if (!validator.isEmail(value)) {
				callback(new Error(t('common.validate.email')));
			} else {
				callback()
			}
		},
		validateAmount(rule, value, callback) {
			value = currencyUtils.reformatMoney(value)
			if (value === '') {
				callback(new Error(t('common.validate.amount')));
			} else {
				callback()
			}
		},
		validatePassword(rule, value, callback) {
			const regExp = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
			if(!regExp.test(value)){
				callback(new Error(t('common.validate.passwordRule')));
			} else {
				callback()
			}
		},
		validateConfirmPwd(rule, value, callback, { password = '' } = {}) {
			try {
				console.log('value', value)
				console.log('password', password)
				if (value !== password) {
					callback(new Error(t('common.validate.passwordInconsistent')));
				} else {
					callback()
				}
			} catch (e) {
				console.log('e', e)
			}
		},
		validateDrag(rule, value, callback) {
			if (value === false) {
				callback(new Error(t('components.drag.validate.slide')))
			} else {
				callback()
			}
		},
		/**
		 * 校验字符集
		 *
		 * @description 目前使用：受益人 - 第三方受益人：地址、账户名称、账户
		 * @param rule
		 * @param value
		 * @param callback
		 */
		validateCharacterSet(rule, value, callback) {
			const regExp = /^[a-zA-Z0-9-/?:().,'+ ]+$/;
			if (value && !regExp.test(value)) {
				callback(new Error(t('common.validate.characterSet')));
			} else {
				callback();
			}
		},
		/**
		 * 校验输入长度
		 *
		 * @param rule
		 * @param value
		 * @param callback
		 * @param length
		 */
		validateCharacterLength(rule, value, callback, { length = 0 } = {}) {
			try {
				if (value.length > length) {
					callback(new Error(t('common.validate.characterLength') + length));
				} else {
					callback()
				}
			} catch (e) {
				console.log('e', e)
			}
		},
		/**
		 * 校验BIC
		 *
		 * @param rule
		 * @param value
		 * @param callback
		 */
		validateBIC(rule, value, callback) {
			if (value && !validator.isBIC(value)) {
				callback(new Error(t('common.validate.bic')));
			} else {
				callback()
			}
		},
		/**
		 * 校验IBAN
		 *
		 * @param rule
		 * @param value
		 * @param callback
		 */
		validateIBAN(rule, value, callback) {
			if (value && !validator.isIBAN(value)) {
				callback(new Error(t('common.validate.iban')));
			} else {
				callback()
			}
		},
		/**
		 * 校验ABA
		 *
		 * @param rule
		 * @param value
		 * @param callback
		 */
		validateABA(rule, value, callback) {
			if (value && !validator.isABA(value)) {
				callback(new Error(t('common.validate.aba')));
			} else {
				callback()
			}
		},
		/**
		 * 校验USCC
		 *
		 * @param rule
		 * @param value
		 * @param callback
		 */
		validateUSCC(rule, value, callback) {
			if (value && !validator.isUSCC(value)) {
				callback(new Error(t('common.validate.uscc')));
			} else {
				callback()
			}
		},
		/**
		 * 校验身份证号
		 */
		validateIdentityCard(rule, value, callback) {
			if (!validator.isIdentityCard(value)) {
				callback(new Error(t('common.validate.idCard')));
			} else {
				callback()
			}
		}
	}

	return {
		...scopedValidators
	}
}
